module.exports = __webpack_public_path__ + "static/media/banking.091f83a1.png";